<template>
    <div class="message-review">
        <div class="content-total">
            <div class="ct-item">
                <h3>提豆成功总金额：</h3>
                <span v-text="withdraw.successAmount"></span><span>元</span>
            </div>
            <div class="ct-item">
                <h3>审核中总金额：</h3>
                <span v-text="withdraw.checkingAmount"></span><span>元</span>
            </div>
        </div>
        <div class="bm-header">
            <div class="block">
                <el-button type="danger" @click="rejectDialog">拒绝</el-button>
                <el-button v-show="useSdk" type="success" @click="approve">同意</el-button>
                <el-button type="success" @click="processed">转人工-已处理</el-button>   
            </div>
        </div>
        <div class="bm-search">
            <div class="block">
                <el-select v-model="status" class="cs-select" placeholder="请选择">
                    <el-option
                    v-for="item in options"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="block">
                <el-date-picker
                    class="time"
                    v-model="time"
                    type="datetimerange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                    format="yyyy-MM-dd HH:mm"
                    value-format="yyyy-MM-dd HH:mm"
                    align="right">
                </el-date-picker>
            </div>
            <div class="block">
                <el-input
                        class="common-el-input"
                        placeholder="输入玩家昵称或ID查询"
                        v-model="searchVal">
                    <i slot="prefix" class="el-input__icon el-icon-search"></i>
                </el-input>
            </div>
            <div class="block">
                <el-button type="primary" @click="getApplyList(1)">搜索</el-button> 
            </div>
        </div>
        <div class="bm-table">
            <el-table :data="applyList" height="100%" @selection-change="handleSelectionChange">
                <el-table-column type="selection" width="55"/>
                <el-table-column label="编号" type="index" align="center"/>
                <el-table-column label="提豆号" prop="withdrawNo" align="center"/>
                <el-table-column label="玩家ID" prop="userRandomId" align="center"/>
                <el-table-column label="玩家昵称" align="center" prop="userNickname"/>
                <el-table-column label="所属俱乐部名称" align="center" prop="clubName"/>
                <el-table-column label="所属子联盟昵称" align="center" prop="subTribeName"/>
                <el-table-column label="所属主联盟昵称" align="center" prop="mainTribeName"/>
                <el-table-column label="交易模式" align="center">
                    <template slot-scope="scope">
                        <div v-if="scope.row.clubTransType == 0">
                            俱乐部充值
                        </div>
                        <div v-else-if="scope.row.clubTransType == 1">
                            平台充值
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="提豆数量" align="center" prop="chip"/>
                <el-table-column label="提豆金额（元）" align="center" prop="amount"/>
                <el-table-column label="申请时间" align="center" prop="createdTime"/>
                <el-table-column label="账号信息" align="center" prop="accountInfo">
                    <template slot-scope="scope">
                        <div>
                            <el-button type="primary" @click="checkInfo(scope.row.id)">查看</el-button> 
                        </div>
                    </template>
                </el-table-column>
                <el-table-column label="提豆状态" align="center">
                    <template slot-scope="scope">
                        <div v-if="scope.row.status == 0">
                            审核中
                        </div>
                        <div v-else-if="scope.row.status == 1">
                            打款中
                        </div>
                        <div v-else-if="scope.row.status == 2">
                            提现成功
                        </div>
                        <div v-else-if="scope.row.status == 3">
                            提现失败
                        </div>
                        <div v-else-if="scope.row.status == 4">
                            
                            <el-tooltip class="item" effect="dark" :content="scope.row.remark" placement="left-start">
                                <el-button>已拒绝</el-button>
                            </el-tooltip>
                        </div>
                        <!-- <el-popover
                            ref="popoverReject"
                            placement="top-start"
                            title="拒绝原因:"
                            width="200"
                            trigger="hover"
                            :content="scope.row.remark">
                        </el-popover> -->
                    </template>
                </el-table-column>
            </el-table>
        </div>

        <el-pagination
                class="common-el-pagination"
                layout="prev,pager,next,jumper"
                background
                :page-size="20"
                :pager-count="5"
                :total="applyListTotal"
                @current-change="getApplyList($event)"/>
        <!-- 查看账户信息 -->
        <el-dialog
            title="账户信息"
            :visible.sync="centerDialogVisible"
            width="30%"
            center>
            <div class="dialog-content">
                <el-form ref="form" :model="accountInfo" label-width="80px">
                    <el-form-item label="户名">
                        <el-input v-model="accountInfo.bankAccName"></el-input>
                    </el-form-item>
                    <el-form-item label="银行卡号">
                        <el-input v-model="accountInfo.bankAccNo"></el-input>
                    </el-form-item>
                    <el-form-item label="银行名称">
                        <el-input v-model="accountInfo.bankName"></el-input>
                    </el-form-item>
                    <el-form-item label="开户行">
                        <el-input v-model="accountInfo.bankOfDeposit"></el-input>
                    </el-form-item>
                    <el-form-item label="联系方式">
                        <el-input v-model="accountInfo.contact"></el-input>
                    </el-form-item>
                </el-form>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="centerDialogVisible = false">关闭</el-button>
            </span>
        </el-dialog>
        <!-- 查看操作信息 -->
        <el-dialog
            title="处理结果"
            :visible.sync="resultDialogVisible"
            @close="closeResultDialog"
            width="80%"
            center>
            <div class="dialog-content">
                <el-table :data="resultList" height="100%">
                    <el-table-column label="提豆号" prop="withdrawNo" align="center"/>
                    <el-table-column label="玩家ID" prop="userRandomId" align="center"/>
                    <el-table-column label="玩家昵称" align="center" prop="userNickname"/>
                    <el-table-column label="所属俱乐部名称" align="center" prop="clubName"/>
                    <el-table-column label="提豆数量" align="center" prop="chip"/>
                    <el-table-column label="提豆金额(元)" align="center" prop="amount"/>
                    <el-table-column label="处理结果" align="center" prop="resultMsg"/>
                </el-table>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button type="primary" @click="closeResultDialog">关闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>
<script>
    import {mapState, mapActions} from 'vuex'

    export default {
        data() {
            return {
                loading: false,
                configIsShow: false,
                profitVal: 1,
                memberUpperLimitVal: 1,
                configForm: {},
                currentPage: 1
            }
        },
        computed: {
            ...mapState('managementMsg', ['clubCreate']),
            ...mapState('union', ['allUnionList']),
            ...mapState('payChannel', ['channelList']),
        },
        watch: {
            profitVal(newVal) {
                if (newVal === 1) return;
                this.configForm.profit = newVal;
            },
            memberUpperLimitVal(newVal) {
                if (newVal === 1) return;
                this.configForm.memberUpperLimit = newVal;
            }
        },
        created() {
            this.getAllUnionList();
            this.getChannelList();
            this.getList();
        },
        methods: {
            ...mapActions('managementMsg', ['getClubCreateList', 'approveClubCreate', 'rejectClubCreate']),
            ...mapActions('union', ['getAllUnionList']),
            ...mapActions('payChannel', ['getChannelList']),
            getList(page = 1) {
                this.loading = true;
                this.currentPage = page;
                this.getClubCreateList(page).then(() => {
                    this.loading = false;
                    if (this.currentPage !== 1 && !this.clubCreate.beanList.length) {
                        this.getList(this.currentPage - 1)
                    }
                });
            },
            setConfigFunc(row) {
                this.profitVal = 1;
                this.memberUpperLimitVal = 1;
                this.configIsShow = true;
                this.configForm = {
                    userId: row.userId,
                    nickname: row.nickname,
                    msgId: row.msgId,
                    profit: '',
                    tribeId: '',
                    memberUpperLimit: '',
                    payChannelId: ''
                }
            },
            approve() {
                 if (!this.configForm.payChannelId) {
                     this.$message.error('请选择代充渠道');
                     return
                 }
                this.approveClubCreate({
                    memberUpperLimit: this.configForm.memberUpperLimit,
                    msgId: this.configForm.msgId,
                    profit: this.configForm.profit,
                    tribeId: this.configForm.tribeId,
                    payChannelId: this.configForm.payChannelId
                }).then(() => {
                    this.configIsShow = false;
                    this.$message.success('申请已批准');
                    this.getList(this.currentPage)
                })
            },
            reject(msgId) {
                this.loading = true;
                this.rejectClubCreate(msgId).then(() => {
                    this.$message.success('申请已拒绝');
                    this.getList(this.currentPage)
                })
            }
        }
    }
</script>
<style lang="scss" scoped>
    .message-review{
        margin-top: 50px;
        .content-total{
            padding: 30px 0;
            display: flex;
            align-items: center;
            .ct-item {
                width: 300px;
                text-align: left;
                display: -webkit-box;
                display: -ms-flexbox;
                display: flex;
                font-size: 13px;
                margin-left: 30px;
                align-items: center;
            }
        }
        .bm-header{
            position: relative;
            display: flex;
            justify-content: flex-end;
            margin: 10px 20px;
            .bm-control{
                width: 200px;
                float: right;
            }
        }
        .bm-search{
            display:flex;
            justify-content: flex-end;
            margin: 10px 10px;
            .block{
                margin-right: 10px;
            }
            .common-el-input{
                width: 200px;
                // margin-right: 20px;
            }
        }  
    }
</style>
